import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

const CursorGlow = () => {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const rx = useSpring(x, { stiffness: 400, damping: 32, mass: 0.5 });
  const ry = useSpring(y, { stiffness: 400, damping: 32, mass: 0.5 });

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setHovering(!!e.target.closest("a,button,[data-cursor]"));
    };
    window.addEventListener("mousemove", move, { passive: true });
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      data-testid="cursor-glow"
      className="fixed top-0 left-0 z-[85] pointer-events-none mix-blend-difference"
      style={{ x: rx, y: ry }}
      aria-hidden="true"
    >
      <motion.div
        animate={{ scale: hovering ? 2.2 : 1, opacity: hovering ? 0.85 : 0.5 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
        className="-translate-x-1/2 -translate-y-1/2 w-7 h-7 rounded-full border border-white/80 bg-white/10"
      />
    </motion.div>
  );
};

export default CursorGlow;
